import styled from 'styled-components';

export const StyledH1 = styled.h1`
  font-size: 32px;
  line-height: 38px;
  color: #2d3540;
  font-weight: bold;
  margin-top: 0;
`;

export const StyledH2 = styled.h2`
  font-size: 28px;
  line-height: 30px;
  color: #2d3540;
  margin: 12px 0;
`;
